import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { getResponseMessage } from '../../../../../utils/utils';
import { getProductsCategory } from '../../../../../crud/categories.crud';
import { IProduct } from '../../../../../interfaces/product';

export const useGetProductsByCategory = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState<IProduct[]>([]);
  const [page, setPage] = useState({ page: 1, perPage: 20, total: 0 });
  const [success, setSuccess] = useState(false);

  const fetch = async (data: {
    id: number;
    page?: number;
    per_page?: number;
    sort_type?: 'new' | 'priceUp' | 'priceDown' | 'updatedAt';
  }) => {
    setLoading(true);
    getProductsCategory(data)
      .then((res: any) => {
        setProducts(res.data.data);
        setSuccess(true);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { page, per_page, total } = res.data;
        setPage({ page, perPage: per_page, total });
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
        }, 200);
      });
  };

  return { fetch, loading, products, page, success };
};
